const path = require('path');
const folderPath = path.resolve(__dirname, "./src/");
const ejsDir = path.resolve(__dirname,'../src/ejs');

// isHtmlMinfy : html minfy 여부
// isTeaser : teaser.html 을 index 로 뽑을지 여부
// isServerComplete : 서버 연동 여부 login 버튼 보이거나 가리기
// isPublish : json data 확장자 json 아니면 oera
// isHtmlTest : 건들지 말기!!!!
let siteData = {
    isConsole : true,
    isServerComplete : true,
    isServerModify: true,
    isJsp: true,

    isHighlights: true,
    isNews: true,
    isMagazine: true,

    url : 'https://www.oera.com',
    url_data : '/static/json/',
    chunks : ['index'],

    url_instagram :'https://www.instagram.com/oera.beauty.official/',

    productCategory : [
        {
            title:"New & Best",
            hash:"new_best"
        },
        {
            title:"Calibrator",
            hash:"calibrator"
        },
        {
            title:"Serum",
            hash:"serum"
        },
        {
            title:"Cream",
            hash:"cream"
        },
        {
            title:"Eye Care",
            hash:"eyecare"
        },
        {
            title:"Toner & Emulsion",
            hash:"toner_emulsion"
        },
        {
            title:"Cleanser",
            hash:"cleanser"
        },
        {
            title:"Special Care",
            hash:"specialcare",
        },
        {
            title:"Cushion",
            hash:"cushion",
        },
        {
            title:"All product",
            hash:"allproduct"
        }
    ],

    //건들지 말기!!!
    isHtmlMinfy: false,
    isHtmlTest: false,
    isOeraExtension : false,
    isTeaser : false,
    isTagging: true
}

// 실제 오픈 데이터
function setOeraData() {
    // siteData.url_data = '/static/json_static/'
    siteData.isConsole = false;
    siteData.isServerComplete = true;
    siteData.isServerModify = true;
    siteData.isHighlights = false;
    siteData.isNews = false;
    siteData.isMagazine = false;
    siteData.isJsp = true;
}

function setLocal() {
    siteData.url_data = '/static/json_static/'
    siteData.isServerComplete = true;
    // siteData.isServerModify = true;
    // siteData.isHighlights = true;
    // siteData.isNews = true;
    // siteData.isMagazine = true;

    siteData.isServerModify = true;
    siteData.isHighlights = false;
    siteData.isNews = false;
    siteData.isMagazine = false;
    siteData.isJsp = false;
}

function setHanTest() {
    //한성백 팀장님이 셋팅한 aws 계정으로 테스트 셋팅
    // siteData.url_data = 'http://oera-aws.designfever.com/static/json/';
    siteData.isServerComplete = true;
    siteData.isServerModify = true;
    siteData.isHighlights = true;
    siteData.isNews = true;
    siteData.isMagazine = true;
    siteData.isJsp = true;
}

// reward 양경식프로님 로컬 테스트용
function setOeraRewardTestData() {
    siteData.url_data = '/static/json_static/'
    siteData.isConsole = true;
    siteData.isServerComplete = true;
    siteData.isServerModify = true;

    siteData.isHighlights = false;
    siteData.isNews = false;
    siteData.isMagazine = false;
    siteData.isJsp = true;
}


// setOeraData();
// setHanTest();
setLocal();

// setOeraRewardTestData();
module.exports = siteData;
